import NotFoundPage from "./ui/NotFoundPage.vue";

export default NotFoundPage;
